import { render, staticRenderFns } from "./BookingPaymentRequestView.vue?vue&type=template&id=5a656d57&scoped=true"
import script from "./BookingPaymentRequestView.vue?vue&type=script&lang=js"
export * from "./BookingPaymentRequestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a656d57",
  null
  
)

export default component.exports